import { Helmet } from 'react-helmet-async';
import "./Patron.css"
import "../../ParafiaWizytowka.css"
import { about, prayers, songs, quotes, photos } from "../../data/patronData.js"
import CustomList from "../../components/CustomList/CustomList.js";
import ImageRow from "../../components/ImageRow/ImageRow.js";
import React, { useState, useEffect } from "react";

function shuffleQuotes(quotes) {
  const shuffled = [...quotes]; 
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
}

export default function Patron () {
  const shuffledQuotes = shuffleQuotes(quotes);

  const getMetaDescription = () => {
    const prayerCount = prayers.length;
    const songCount = songs.length;
    const quoteCount = quotes.length;
    const aboutPreview = about.length > 150 ? about.substring(0, 150) + "..." : about;
    
    return `Święta Urszula Ledóchowska (1865-1939) - założycielka urszulanek Serca Jezusa Konającego. ${aboutPreview} Na stronie: ${prayerCount} modlitw, ${songCount} pieśni, ${quoteCount} cytatów. Patronka parafii w Częstochowie.`;
  };

  return (
    <>
      <Helmet>
        <title>Święta Urszula Ledóchowska – Patronka parafii – Częstochowa</title>
        <meta name="description" content={getMetaDescription()} />
        <meta name="keywords" content="św. Urszula Ledóchowska, patronka parafii, biografia, życiorys, modlitwy do św. Urszuli, pieśni, cytaty, urszulanki Serca Jezusa Konającego, Częstochowa, Wrzosowiak" />
        <meta property="og:title" content="Święta Urszula Ledóchowska – Patronka parafii" />
        <meta property="og:description" content={`Poznaj życie i duchowość św. Urszuli Ledóchowskiej, patronki naszej parafii. Modlitwy, pieśni i cytaty. ${about.substring(0, 100)}...`} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://swurszula.pl/sw-urszula" />
        <meta property="og:image" content={photos[0]} />
        <meta property="og:image:alt" content="Święta Urszula Ledóchowska" />
        <meta property="og:locale" content="pl_PL" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Święta Urszula Ledóchowska – Patronka parafii" />
        <meta name="twitter:description" content={`Życiorys, modlitwy i cytaty św. Urszuli Ledóchowskiej. Patronka parafii w Częstochowie.`} />
        <meta name="twitter:image" content={photos[0]} />
      </Helmet>

      <section className="patron-container">
        <h2 className="section-title">Święta Urszula Ledóchowska</h2>
        <ImageRow images={photos} alt={"Święta Urszula Ledóchowska – zdjęcia i wizerunki"} />
        <img 
          src="/assets/11.png" 
          alt="Dekoracyjna linia – św. Urszula Ledóchowska" 
          className="patron-divider" 
        />
        <p className="patron-text">{about}</p>
        <br/>
        <h2 className="section-title">Modlitwy</h2>
        <CustomList items={prayers} />
        <br/>
        <h2 className="section-title">Pieśni</h2>
        <CustomList items={songs} />
        <br/>
        <h2 className="section-title">Cytaty</h2>
        {shuffledQuotes.map((quote, index) => (
          <div key={index} className="quote-card">
            <p className="quote-text">"{quote.text}"</p>
            {quote.source && <p className="quote-source">— {quote.source}</p>}
            <img 
              src="/assets/18.png" 
              alt="Dekoracyjny separator – cytat św. Urszuli Ledóchowskiej" 
              className="quote-divider" 
            />
          </div>
        ))}
      </section>
    </>
  );
}